import BlockIcon from "@mui/icons-material/Block";

export const JobApplicationClosureReasonIcon = BlockIcon;
